export default __webpack_public_path__ + "static/media/icon-sms-code.a2504281.svg";